import request from '@/utils/request'

export function getBusinessOverview(query)
{
    return request({
        url:'/business/getBusinessOverview',
        method:'get',
        params: query
    })
}
export function getLargeScreenWeatherData(query)
{
    return request({
        url:'/business/getLargeScreenWeatherData',
        method:'get',
        params: query
    })
}